<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        海大智龙360°视景大型航海船舶操纵模拟器在泉州海洋职业学院投入运行
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
           <div class="div-text-left news-Regular-14b6">
            <span>2020-05-25</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
           </div>
      <div class="div-line  divcss5"></div>
 
      <div class="div-row div-bottom10">
          <p class="indentation">
        近日，大连海大智龙科技有限公司的360度视景航海船舶操纵模拟器在泉州海洋职业学院投入运行。
        </p>  
           <p class="indentation"> 该模拟器采用当今世界先进的技术手段和方法，如计算机成像技术、虚拟现实技术等，是航海技术专业的重点实验室。该系统由教练员控制台、1条主本船、4条副本船、视景系统及多媒体教室组成。主本船采用360°无缝拼接宽视场角环幕投影技术，所采用的先进的技术和设备在国内外同行业中位居前茅。各本船均配置有船舶操控系统、电子海图系统、航海仪器系统、3D视景系统等。满足STCW公约、《中华人民共和国海船船员培训大纲》、《中华人民共和国海船船员适任评估规范》中关于船员培训与评估的要求，并通过了挪威船级社（A级）认证及中国船级社认证。各本船之间通过三维视景和雷达图像互见,三维视景带有船舶动态数据仪表显示功能，丰富港口视景库包含国内外50多个港口和航段，数字化的港口及相关设施动态、逼真地展现在大家面前。船舶类型全面，不仅包含散货船、液货船、集装箱船、杂货船等常用船舶类型，还包括邮轮、高速艇、军舰等特殊类型船舶，多达 110多条。此外还可设置逼真的训练环境，模拟不同的水域：峡水道、分道通航，运河，外海等水域。具备24小时天空环境连续变化功能，可以模拟出不同的天气现象有风、浪、雨、雪及白天、黑夜等。 </p>  
              <p class="indentation"> 这套系统不仅用于航运专业学生的实操训练，还可应用于船员的船舶操纵、避碰和驾驶台资源管理等方面的能力培训和考试，给船员提供公平的考试平台。系统还将用于VTS、渔业操作、内河航行、游艇操纵、溢油应急、搜寻救助等操作训练、港航工程论证和智能船用设备验证等科学研究，并作为青少年航海科普教育场所。 </p>  
      </div>
      <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news19/1.png" />
          </div>
        </div>
      </div>

         <div class="div-row div-bottom10">
        <div class=" div-top box2">
                 <div class="div-margin ">
             <img src="../../../assets/images/news19/2.png" />
          </div>
        </div>
      </div>
         <div class="div-row div-bottom10">
        <div class=" div-top box2">
                 <div class="div-margin ">
             <img src="../../../assets/images/news19/3.png" />
          </div>
        </div>
      </div>
         <div class="div-row div-bottom10">
        <div class=" div-top box2">
                 <div class="div-margin ">
             <img src="../../../assets/images/news19/4.png" />
          </div>
        </div>
      </div>
         <div class="div-row div-bottom10">
        <div class=" div-top box2">
                 <div class="div-margin ">
             <img src="../../../assets/images/news19/5.png" />
          </div>
        </div>
      </div>
   
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {

    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }
  img {
    vertical-align: middle;
    border-style: none;
    width: 90%; 
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news19.vue